import React, { useEffect, useState } from "react";
import QuestionBlock from "./QuestionBlock";
import Result from "./Result";
import questionsData from "./data/questions.json";
import classificationData from "./data/classification.json";

const App: React.FC = () => {
  const [currentBlockIndex, setCurrentBlockIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState<any[]>([]);
  const [totalScore, setTotalScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const blocks = questionsData.blocks;


  useEffect(() => {
    if (currentBlockIndex >= blocks.length) {
      setShowResult(true);
    }
  }, [currentBlockIndex, blocks.length]);

  const handleAnswer = (answer: boolean, score: number) => {
    const currentBlock = blocks[currentBlockIndex];
    const nextQuestionIndex = answer ? 0 : currentQuestionIndex + 1;
    const blockType = currentBlock.type;

    setAnswers([
      ...answers,
      { question: currentBlock.questions[currentQuestionIndex].text, answer },
    ]);

    if (answer) {
      if (blockType === 'multiplication') {
        setTotalScore(totalScore * score);
      } else {
        setTotalScore(totalScore + score);
      }

      if (currentBlockIndex + 1 < blocks.length) {
        setCurrentBlockIndex(currentBlockIndex + 1);
        setCurrentQuestionIndex(0); // Reset question index for the new block
      } else {
        setCurrentBlockIndex(currentBlockIndex + 1); // Increment to trigger useEffect
      }


    } else {
      if (nextQuestionIndex >= currentBlock.questions.length) {
        if (blockType === 'multiplication') {
          setTotalScore(totalScore * currentBlock.defaultScore);
        } else {
          setTotalScore(totalScore + currentBlock.defaultScore);
        }

        setCurrentQuestionIndex(0);
        setCurrentBlockIndex(currentBlockIndex + 1);
    } else {
      setCurrentQuestionIndex(nextQuestionIndex);
    }
  }
  };

  const handleReset = () => {
    setCurrentBlockIndex(0);
    setCurrentQuestionIndex(0);
    setAnswers([]);
    setTotalScore(0);
    setShowResult(false);
  };

  const getClassification = (score: number) => {
    const classification = classificationData.classifications.find(classification => {
      const [min, max] = classification.range.split(" to ").map(Number);
      return score >= min && (max ? score <= max : true);
    });
    return classification ? classification.name : "Unknown";
  };

  return (
    <div>
      {showResult ? (
        <Result
          totalScore={totalScore}
          classification={getClassification(totalScore)}
          answers={answers}
          onReset={handleReset}
        />
      ) : (
        <QuestionBlock
          block={blocks[currentBlockIndex]}
          questionIndex={currentQuestionIndex}
          onAnswer={handleAnswer}
        />
      )}
    </div>
  );
};

export default App;